import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateServiceSchema } from '@/utils/seo';
import ServicePageLayout, { ServicePageConfig } from '@/pages/service-common/ServicePageLayout';

/* ─── Hero Background ─── */
const HERO_IMG = 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20golden%20digital%20interface%20elements%20and%20web%20grid%20lines%20on%20deep%20navy%20blue%20background%20minimal%20sophisticated%20high-end%20corporate%20aesthetic%20soft%20glowing%20particles%20no%20text&width=1920&height=800&seq=webhero1&orientation=landscape';

const config: ServicePageConfig = {
  pageLabel: 'Webサイト制作',
  heroImage: HERO_IMG,
  tag: 'Web Creation',
  title: <>47サイト・133ページの<br />実績が証明する制作力</>,
  subtitle: '美しいデザインと高いパフォーマンスを両立したWebサイトを制作。コーポレートサイトからECまで、ビジネス目標を達成するデジタル体験を提供します。',
  icon: 'ri-global-line',
  services: [
    { icon: 'ri-building-4-line', title: 'コーポレートサイト', desc: 'ブランドの世界観を表現し、信頼性と訴求力を兼ね備えた企業サイトを制作します。' },
    { icon: 'ri-shopping-cart-line', title: 'ECサイト', desc: 'コンバージョン最適化された、売れるECプラットフォームを設計・構築します。' },
    { icon: 'ri-layout-2-line', title: 'ランディングページ', desc: 'キャンペーン目標に直結する、高転換率のLPを素早くリリースします。' },
    { icon: 'ri-window-line', title: 'Webアプリケーション', desc: 'インタラクティブで高機能なWebアプリを、最新技術で構築します。' },
    { icon: 'ri-smartphone-line', title: 'レスポンシブデザイン', desc: 'あらゆるデバイスで最高の体験を提供するレスポンシブサイトを実現します。' },
    { icon: 'ri-article-line', title: 'CMS連携', desc: 'WordPressなど主要CMSとの連携で、更新しやすいサイトを構築します。' },
  ],
  steps: [
    { title: '要件整理・企画', desc: 'ビジネス目標とターゲットユーザーを明確化し、プロジェクトのスコープを定義します。' },
    { title: 'UX設計・デザイン', desc: 'ユーザー中心のデザインプロセスで、美しく使いやすいUIを設計します。' },
    { title: '開発・実装', desc: 'モダンな技術スタックで、高速・セキュアなサイトを丁寧に実装します。' },
    { title: 'テスト・公開', desc: '品質チェックを経て、スムーズなローンチを実現します。' },
    { title: '保守・改善', desc: '公開後も継続的にデータを分析し、成果を高める改善を続けます。' },
  ],
  stats: [
    { number: '47', label: 'サイト制作実績' },
    { number: '133', label: 'ページ制作数' },
    { number: '98%', label: 'クライアント満足度' },
    { number: '2x', label: '平均CV率向上' },
  ],
  benefits: [
    '47サイト・133ページの豊富な制作実績に裏打ちされた高い品質',
    'SEO・パフォーマンス最適化で検索流入と表示速度を同時に向上',
    'コンバージョンを意識した設計で、サイトからの問い合わせ・購入を最大化',
    'すべてのデバイスで完璧な表示と操作性を実現するレスポンシブ対応',
    'マーケティングツールとの連携でサイトをビジネス成長の中核に据える',
    'CMS導入で更新・管理が簡単になり、継続的な情報発信を支援',
  ],
};

export default function WebCreationPage() {
  useSEO({
    title: '東京 Webサイト制作 TradFit株式会社 | コーポレート・EC・LP制作',
    description: 'TradFit株式会社のWebサイト制作サービス。47サイト・133ページの制作実績。コーポレートサイトからECまで、ビジネス目標を達成するデジタル体験を提供します。',
    keywords: 'Webサイト制作, コーポレートサイト, ECサイト, ランディングページ, 東京',
    path: '/web-creation',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebPageSchema('Webサイト制作 | TradFit株式会社', 'TradFit株式会社のWebサイト制作サービス。', '/web-creation'),
        generateBreadcrumbSchema([{ name: 'ホーム', path: '/' }, { name: '事業内容', path: '/business' }, { name: 'Webサイト制作', path: '/web-creation' }]),
        generateServiceSchema('Webサイト制作', 'コーポレートサイトからECまでのWebサイト制作サービス。'),
      ],
    },
  });
  return <ServicePageLayout config={config} />;
}
